import { ApiService } from '../../../services/api_service';
import { DataService } from '../../../services/data_service';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { i18n } from '../../../i18n/i18n';
import { IDs } from '../../../helpers/IDs';
import { ImportGtz } from './functions/ImportGtz';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { saveInChunks } from '../kennzahlen/saveInChunks';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

export interface DatenverwaltungGtzProps {
    data: any;
}

export interface DatenverwaltungGtzState {
    dataImport: any;
    isLoading: boolean;
    isSaving: boolean;
    jahrCur: number;
    jahrMax: number;
    jahrMin: number;
    showDownloadDialog: boolean;
}

export class DatenverwaltungGtz extends React.Component<DatenverwaltungGtzProps, DatenverwaltungGtzState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataImport: {},
            isLoading: false,
            isSaving: false,
            jahrCur: null,
            jahrMax: null,
            jahrMin: null,
            showDownloadDialog: false
        };
        this.isSaved = this.isSaved.bind(this);
        this.onDownload = this.onDownload.bind(this);
        this.onSave = this.onSave.bind(this);
        this.setDownloadJahr = this.setDownloadJahr.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.getJahre();
    }

    downloadFile(path: string, callback?: (data: any, success: boolean) => void): void {
        this.apiService.call('getRessource', { path: path || null, mode: 'proxy', override: 1 }, (data: string, success: boolean) => {
            if ((!success || !(data || '').length) && typeof callback === 'function') {
                callback(data, false);
            }

            if (typeof callback === 'function') {
                callback(data, success);
            }
        });
    }

    getJahre(): void {
        const parameter: any[] = this.props.data[IDs.ENT_SYSTEMPARAMETER] || [];
        const start_jahr: number = (parameter
            .find((element: any) => (element.parameter || null) === 'gtz_start_jahr')).wert || null;
        const download_jahr: number = (parameter
            .find((element: any) => (element.parameter || null) === 'gtz_download_jahr')).wert || null;
        const jahrMax: number = new Date().getFullYear() - 1;
        const jahrMin: number = start_jahr > 1900 ? (start_jahr > jahrMax ? +jahrMax : +start_jahr) : 2010;
        const jahrCur: number = (download_jahr >= jahrMin && download_jahr <= jahrMax) ? +download_jahr : null;
        this.setState({ jahrCur, jahrMax, jahrMin });
    }

    isSaved(success: boolean): void {
        if (success) {
            this.triggerService.fire('reload', IDs.ENT_GTZ);
            this.triggerService.fire('admin_reload', IDs.ENT_GTZ_ORTE);
            this.setDownloadJahr();
        } else {
            alert(i18n('Die Datensätze konnten nicht gespeichert werden.', 'sys'));
        }
        this.setState({ dataImport: {}, isSaving: false });
    }

    onDownload(): void {
        const files: any[] = this.getFiles() || [];
        let counter: number = files.length;
        let error: boolean = false;

        if (!files.length) {
            this.setState({ isLoading: false, showDownloadDialog: true });
            return;
        }
        const Import = new ImportGtz(this.props.data || []);

        const getData = (file: string) => {
            this.downloadFile(
                file || null,
                (data: any, success: boolean) => {
                    if (success) {
                        console.log(
                            file.split('/')[file.split('/').length - 1].substring(9, 15),
                            new Date().toLocaleString(),
                            (data || '').toString().length,
                            file
                        );
                        Import.setData(data, 5);

                        if (!--counter) {
                            if (error) {
                                this.setState({ isLoading: false, showDownloadDialog: true }, () => {
                                    alert(i18n('Es ist ein Problem aufgetreten, versuchen Sie es später erneut.', 'sys'));
                                });
                                return;
                            }
                            this.setState({
                                isLoading: false,
                                showDownloadDialog: true,
                                dataImport: {
                                    ...this.state.dataImport,
                                    orte: Import.getDataOrte(),
                                    insert: Import.getDataInsert()
                                }
                            });
                        }
                    } else {
                        error = true;
                    }
                }
            );
        };
        this.setState({ isLoading: true });

        files.forEach((file: string, index: number) => setTimeout(() => getData(file), index * 500));
    }

    getFiles(): string[] {
        // historical: new Date().getFullYear() - 6
        // https://opendata.dwd.de/climate_environment/CDC/derived_germany/techn/monthly/heating_degreedays/hdd_3807/historical/gradtage_201001.csv
        // recent: 6 last years
        // https://opendata.dwd.de/climate_environment/CDC/derived_germany/techn/monthly/heating_degreedays/hdd_3807/recent/gradtage_202401.csv
        const files: string[] = [];
        const url: string = ((this.props.data[IDs.ENT_SYSTEMPARAMETER] || [])
            .find((element: any) => (element.parameter || null) === 'gtz_url')).wert || null;
        const { jahrCur, jahrMax, jahrMin } = this.state;
        let jahr: number = jahrCur ? jahrCur + 1 : jahrMin;

        if (!jahrMax || !jahrMin) {
            return [];
        }

        for (; jahr <= jahrMax; ++jahr) {
            const subpath: string = (jahr < new Date().getFullYear() - 6) ? 'historical' : 'recent';

            for (let monat = 1; monat <= 12; ++monat) {
                const monatString: string = monat > 9 ? monat.toString() : '0' + monat;
                files.push(`${url}${subpath}/gradtage_${jahr}${monatString}.csv`);
            }
        }

        return files;
    }

    onSave(callback: (success: boolean) => void): void {
        const orte: any[] = (this.state.dataImport || {}).orte || [];

        const setData = () => {
            this.dataService.loadData(IDs.ENT_GTZ_ORTE, {}, {}, (obj: any, entity: string) => {
                const gtz_orte: any[] = obj[entity] || [];
                this.setData(IDs.ENT_GTZ, this.setOrtTids(gtz_orte), (success: boolean) => callback(success));
            }, IDs.MOD_ETOOL_ADMIN);
        };
        this.setData(IDs.ENT_GTZ_ORTE, orte, setData);
    }

    render(): JSX.Element {
        return <>
            <WFormsTableWrapper
                entity={IDs.ENT_GTZ}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                externalHeaderElements={this.renderHeaderElements()}
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_GTZ)}
                showColumnsHelp
            />
            {this.state.isLoading && <WSpinner label={i18n('Laden', 'sys')} />}
            {this.state.showDownloadDialog && this.renderDownloadDialog()}
        </>;
    }

    renderDownloadDialog(): JSX.Element {
        return (
            <div>
                <DialogWrapper2
                    title={'Gradtagzahlen herunterladen'}
                    onAfterClose={() => this.setState({ showDownloadDialog: false })}
                >
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'column', minWidth: 400, padding: 16, boxSizing: 'border-box' }}>
                        <div style={{}}>
                            {this.renderOrte()}
                            <br />
                            {this.renderGtz()}
                            <br />
                            {this.renderJahre()}
                        </div>
                        <div style={{ textAlign: 'right', position: 'absolute', right: 0, bottom: 0, left: 0, padding: '0.4em 1em' }}>
                            {this.renderSaveButton()}
                        </div>
                    </div>
                    {this.state.isSaving && <WSpinner label={i18n('Senden', 'sys')} />}
                </DialogWrapper2>
            </div>
        );
    }

    renderGtz(): JSX.Element {
        const anzahl: number = ((this.state.dataImport || {}).insert || []).length;
        // this.dataService.loadData(IDs.ENT_GTZ_ORTE, {}, {}, (obj: any, entity: string) => {
        //     const gtz_orte: any[] = obj[entity] || [];
        //     console.info('RESULT:', this.setOrtTids(gtz_orte));
        // }, IDs.MOD_ETOOL_ADMIN);
        return (
            <div>
                <strong>Gradtagzahlen:</strong>&nbsp;
                <span style={{ color: 'green' }}>+{anzahl}</span>
            </div>
        );
    }

    renderHeaderElements(): JSX.Element[] {
        return [
            <WActionButton
                label='Gradtagzahlen herunterladen'
                insideText='Gradtagzahlen herunterladen'
                key='download_gtz'
                action='import'
                onAction={this.onDownload}
                disabled={this.state.showDownloadDialog}
            />
        ];
    }

    renderJahre(): JSX.Element | JSX.Element[] {
        const jahre: JSX.Element[] = [];
        const { jahrCur, jahrMax, jahrMin } = this.state;

        if (!jahrMax || !jahrMin) {
            return <div>Fehlerhafte Systemparameter!</div>;
        }

        for (let jahr: number = jahrMin; jahr <= jahrMax; ++jahr) {
            const checked: boolean = jahr <= (jahrCur || jahrMin - 1);
            jahre.push(
                <div key={`jahr-${jahr}`}>
                    <input
                        type='checkbox'
                        checked={checked}
                        disabled
                    />
                    {jahr}
                </div>
            );
        }

        return jahre;
    }

    renderOrte(): JSX.Element {
        const anzahl: number = ((this.state.dataImport || {}).orte || []).length;

        return (
            <div>
                <strong>Orte:</strong>&nbsp;
                <span style={{ color: 'green' }}>+{anzahl}</span>
            </div>
        );
    }

    renderSaveButton(): JSX.Element {
        const disabled: boolean = Object.keys(this.state.dataImport || {}).length === 0
            || ((this.state.dataImport || {}).insert || []).length === 0
            || this.state.isSaving;

        return (
            <WActionButton
                label={i18n('Speichern', 'sys')}
                insideText={i18n('Speichern', 'sys')}
                key='save'
                action='save'
                styleProps={ disabled && { backgroundColor: 'lightgray', cursor: 'not-allowed' } }
                onAction={() => this.onSave(this.isSaved)}
                disabled={disabled}
            />
        );
    }

    setData(entity: string, data: any[], callback: (success: boolean) => void): void {
        this.setState({ isSaving: true }, () => saveInChunks(
            data || [], this.dataService, entity, IDs.MOD_ETOOL_ADMIN,
            () => typeof callback === 'function' ? callback(true) : null
        ));
    }

    setDownloadJahr(): void {
        const entity: string = IDs.ENT_SYSTEMPARAMETER || null;
        const jahrMax: number = this.state.jahrMax || null;
        const tid: number = ((this.props.data[entity] || [])
            .find((element: any) => (element.parameter || null) === 'gtz_download_jahr')).tid || null;

        this.dataService.updateDataSingle(
            entity,
            tid,
            { wert: jahrMax },
            (success: boolean) => {
                if (success) {
                    this.setState({ jahrCur: jahrMax }, () => this.triggerService.fire('admin_reload', entity));
                }
            },
            IDs.MOD_ETOOL_ADMIN
        );
    }

    setOrtTids(data: any[]): any[] {
        const orte: any = {};

        (data || []).forEach((item: any) => {
            orte[item.id] = item.tid;
        });

        return ((this.state.dataImport || {}).insert || [])
            .map((item: any) => { return { ...item, ort_tid: orte[item.ort_tid] || 0 }; });
    }
}
